(function() {
	'use strict';

	var forms = document.querySelectorAll('.form-section');
	if (forms) {
		forms.forEach(function (form){
			if (form.querySelectorAll('.avast-form').length > 0) {
				var
					togglers = form.querySelectorAll('.form-controler .toggler-item'),
					radios = form.querySelectorAll('.avast-form input[type=radio]'),
					defaultSelection = form.querySelector('.form-controler .toggler-item.selected'),
					defaultTarget = defaultSelection.getAttribute('target'),

					togglerSwitch = function(togglers, toggler, radios) {
						console.log('switched');
						togglers.forEach(function(item){
							item.classList.remove('selected');
						});

						toggler.classList.add('selected');
						var target = toggler.getAttribute('target');
						
						setInputsVisibility(target);
						setRadios(radios, target);
					},

					setInputsVisibility = function(target) {
						var
							inputUrl = form.querySelector('.form-item input[name=url]'),
							inputFile = form.querySelector('.form-item input[name=file]');
						
						inputUrl.closest('div.form-group').classList.add('hidden');
						inputFile.closest('div.form-group').classList.add('hidden');

						// 'target' param indicates that method was called by toggler switch (initial input hiding is done by forms-fetch.js)
						if(target && target == 'website'){
							inputUrl.closest('div.form-group').classList.remove('hidden');
						} else if(target && target == 'file'){
							inputFile.closest('div.form-group').classList.remove('hidden');
						}

						// re-init tooltips
						document.querySelectorAll(".label[data-bs-toggle='tooltip']").forEach(function(tooltip){
							var bsnTip = new BSN.Tooltip(tooltip);
						});
					},
				
					// Set the proper radio checked according to togglers; needed for backend processing of the form
					setRadios = function(radios, target) {
						radios.forEach(function (radio){
							radio.removeAttribute('checked'); // reset radios
							radio.checked = false; // reset radios
						});
				
						for (var i = 0; i < radios.length; i++) {
							if (target == radios[i].value) {
								radios[i].setAttribute('checked','');
								radios[i].checked = true;
								break;
							}
						};
					};

				setInputsVisibility(defaultTarget);

				togglers.forEach(function(toggler){
					toggler.addEventListener("click", function(){
						togglerSwitch(togglers, this, radios);
					});
				});
			}
		});
		
		// Init tooltip after window load
		window.addEventListener("load", function(){
			document.querySelectorAll(".label[data-bs-toggle='tooltip']").forEach(function(tooltip){
				// add info icon after tooltips
				var i = document.createElement('span');
				i.setAttribute('role', 'img');
				i.classList.add('icon', 'icon-16', 'icon-info');
				tooltip.appendChild(i);

				// init tooltip after all content manipulations by JS
				var bsnTip = new BSN.Tooltip(tooltip);
			});
		});
	}
})();